import { useBridgeContext } from '@sendible/shared-state-bridge';

export const useUrlWithCredentials = () => {
  const [bridgeContext] = useBridgeContext();

  if (!bridgeContext?.user) {
    return (url: string) => url;
  }

  const { user } = bridgeContext;

  return (url: string) => {
    let credentials = `access_token=${user.accessToken}`;

    if (user.isSwitchedUser) {
      credentials = `username=${user.username}&logged_in_access_token=${user.accessToken}`;
    }

    return `${url}?${credentials}`;
  };
};
